import type { BlogPost } from "./blog";

export const BLOG_CUISINE_PART1: BlogPost[] = [
  {
    "slug": "avtorskaya-kukhnya-peterburg-trendy",
    "title": "Авторская кухня Петербурга: тренды и лучшие места 2026",
    "metaTitle": "Авторская кухня Петербурга 2026 — тренды и места | Паруса на крыше",
    "metaDescription": "Авторская кухня в Санкт-Петербурге: что это такое, тренды 2026 года и где её попробовать. «Паруса на крыше» — авторское меню с локальными продуктами Северо-Запада.",
    "keywords": "авторская кухня петербург тренды, авторская кухня спб 2026, лучшая авторская кухня петербург",
    "date": "2026-06-01",
    "category": "Кухня и меню",
    "readTime": 8,
    "image": "/photos/food.webp",
    "lead": "Авторская кухня в Петербурге переживает расцвет. Шефы всё активнее обращаются к локальным продуктам Северо-Запада, переосмысливают традиции и создают блюда с петербургским характером. Разбираем тренды и места.",
    "sections": [
      {
        "heading": "Что такое авторская кухня в 2026 году",
        "body": "Авторская кухня — это когда шеф создаёт оригинальные блюда, а не воспроизводит чужие рецепты. В 2026 году петербургская авторская кухня определяется несколькими трендами: локальность (продукты Северо-Запада), сезонность (меню меняется 4 раза в год), минимализм в подаче (красота продукта, а не декора), работа с ферментацией и заготовками (северные традиции). В «Парусах на крыше» всё это реализовано: шеф работает с балтийской рыбой, карельскими грибами, новгородскими ягодами.",
        "list": [
          "Локальные продукты Северо-Запада: рыба, грибы, ягоды",
          "Сезонное меню — обновляется 4 раза в год",
          "Фермерские поставщики — прямая связь с производителями",
          "Нордическое влияние — северные традиции в современной интерпретации"
        ]
      },
      {
        "heading": "Тренды петербургской кухни 2026",
        "body": "Тренд 1: «нео-нордик» — скандинавские техники в петербургском контексте: вяленая рыба, копчение, ферментация. Тренд 2: морепродукты Балтики — гребешки, мидии, треска в авторской интерпретации. Тренд 3: локальные злаки и корнеплоды — турнепс, репа, полба, которые раньше считались «крестьянскими», сейчас в меню топовых ресторанов. Тренд 4: растительная кухня, интегрированная в «мясное» меню — не как веганский раздел, а как полноценные позиции.",
        "highlight": "Фирменный тренд «Парусов»: балтийская рыба в нордическом стиле + авторские соусы на основе северных ягод. Это вкус Петербурга, который нельзя попробовать больше нигде."
      },
      {
        "heading": "Как выбирать авторскую кухню правильно",
        "body": "Признаки настоящей авторской кухни: меню меняется сезонно, есть позиции которых нет в других ресторанах, официант знает историю блюда, и — главное — после ужина вы помните конкретные вкусы. В «Парусах» гости в отзывах называют конкретные блюда: «гребешки были фантастические», «торт от шефа — лучший в городе» — это признак авторской кухни, которая запоминается."
      }
    ],
    "cta": {
      "text": "Попробовать авторскую кухню «Парусов»",
      "href": "/menu"
    }
  },
  {
    "slug": "menu-restoran-peterburg-chto-zakazat",
    "title": "Что заказать в ресторане Петербурга: советы гурмана",
    "metaTitle": "Что заказать в ресторане Петербурга — советы | Паруса на крыше",
    "metaDescription": "Что заказывать в хорошем ресторане Петербурга? Советы по выбору блюд и напитков. «Паруса на крыше» — фирменные блюда, которые стоит попробовать.",
    "keywords": "что заказать ресторан петербург, меню ресторан петербург советы, лучшие блюда петербург ресторан",
    "date": "2026-06-01",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Как выбрать из меню хорошего ресторана, если не знаешь, что попробовать? Несколько правил, которые работают в «Парусах на крыше» и в любом авторском ресторане.",
    "sections": [
      {
        "heading": "Стратегия выбора из меню",
        "body": "Три правила: 1. Начните с фирменных блюд — спросите официанта «что из авторских позиций особенно популярно?». В «Парусах» это гребешки, блюда на хоспере и десерт от шефа. 2. Выбирайте то, что сезонно — блюда из сезонных продуктов всегда лучше несезонных. 3. Не бойтесь задать вопрос — хороший официант рекомендует честно, не по цене.",
        "list": [
          "Гребешки с цветной капустой и икрой — фирменное блюдо",
          "Блюда на хоспере (живой огонь) — стейки, рёбра, рыба",
          "Авторский десерт от шефа-кондитера — обязательно попробовать",
          "Сезонные блюда — уточните у официанта что сейчас особенно свежее"
        ]
      },
      {
        "heading": "Что заказывать на разные поводы",
        "body": "Романтический ужин: закуска на двоих (гребешки) → горячее по одному (стейк и рыба, чтобы попробовать оба) → авторский десерт. Деловой обед: суп дня + горячее + кофе — быстро и сытно. День рождения: полное дегустационное меню, на которое официант ориентирует сам. Просто ужин: выбирайте то, что давно хотели попробовать — авторская кухня для экспериментов.",
        "highlight": "Лайфхак: скажите официанту «я у вас впервые, что посоветуете?» — и получите персональное меню из лучших позиций."
      },
      {
        "heading": "Как читать авторское меню",
        "body": "Авторское меню часто содержит непривычные сочетания: «гребешок с цветной капустой и икрой» или «говядина с репой и соусом из морошки». Это не эксперимент ради эксперимента — это продуманные сочетания. Доверяйте шефу: если блюдо в меню уже несколько сезонов подряд, значит, гости его полюбили."
      }
    ],
    "cta": {
      "text": "Посмотреть меню «Парусов»",
      "href": "/menu"
    }
  },
  {
    "slug": "rybnye-blyuda-peterburg-restoran",
    "title": "Рыбные блюда в ресторанах Петербурга: где лучшая рыба",
    "metaTitle": "Рыбные блюда в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Рыбные блюда в ресторанах Санкт-Петербурга. Где попробовать лучшую балтийскую рыбу? «Паруса на крыше» — авторские рыбные блюда, сезонная балтийская рыба.",
    "keywords": "рыбные блюда рестораны петербург, рыба ресторан спб, балтийская рыба ресторан петербург",
    "date": "2026-06-02",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Петербург — портовый город. Рыба здесь — не просто продукт, это гастрономическая традиция. Балтийская треска, карельский лосось, невская корюшка — всё это часть петербургской кулинарной идентичности.",
    "sections": [
      {
        "heading": "Балтийская рыба в петербургской кухне",
        "body": "Петербург исторически связан с Балтийским морем и реками Северо-Запада. Рыбная традиция включает: балтийскую треску (плотная, ненавязчивый вкус, хорошо в авторских блюдах), карельский лосось (жирный, насыщенный, идеален для копчения и тартара), невскую корюшку (сезонный деликатес — апрель-май, фирменный петербургский продукт), речного сига и снетка. В «Парусах на крыше» шеф работает с сезонными локальными видами, меню по рыбе меняется несколько раз в год.",
        "list": [
          "Балтийская треска — в меню круглый год",
          "Карельский лосось — тартар, стейк, копчение",
          "Корюшка — сезонно (апрель–май), главный петербургский продукт",
          "Гребешки — главный деликатес авторской кухни ресторана"
        ]
      },
      {
        "heading": "Что попробовать в «Парусах»",
        "body": "Гребешки с цветной капустой и икрой — фирменное блюдо, которое регулярно упоминают в отзывах. Тартар из лосося — авторская интерпретация с северными акцентами. Рыбное горячее по сезону — уточняйте у официанта, что сегодня особенно свежее. Уха — авторская версия традиционного блюда, если есть в меню.",
        "highlight": "Просите сезонную рыбу: шеф предпочитает работать с тем, что сейчас в лучшей форме. Официант знает, что сегодня наиболее свежее."
      },
      {
        "heading": "Вино к рыбе: что заказывать",
        "body": "К белой рыбе (треска, сиг): сухое белое вино — шабли, совиньон блан, пино гри. К лососю и жирной рыбе: розовое вино или лёгкое красное — пино нуар. К морепродуктам (гребешки, устрицы): игристое или мюскаде. Официант «Парусов» поможет с подбором — карта вин составлена с учётом меню."
      }
    ],
    "cta": {
      "text": "Попробовать рыбные блюда",
      "href": "/menu"
    }
  },
  {
    "slug": "myasо-na-khospere-restoran-spb",
    "title": "Мясо на хоспере в Петербурге: где лучший стейк",
    "metaTitle": "Мясо на хоспере в Петербурге — лучший стейк | Паруса на крыше",
    "metaDescription": "Мясо на хоспере в ресторанах Санкт-Петербурга. Где лучший стейк и мясо на живом огне? «Паруса на крыше» — хоспер-блюда в авторском меню.",
    "keywords": "мясо хоспер петербург ресторан, стейк хоспер спб, хоспер ресторан петербург",
    "date": "2026-06-02",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Хоспер — это печь на дровах или угле, которая даёт мясу особый вкус: дымный аромат, карамелизированную корочку и сочность внутри. Мясо с хоспера — отдельная гастрономическая категория.",
    "sections": [
      {
        "heading": "Что такое хоспер и почему это важно",
        "body": "Хоспер — профессиональная жарочная печь, работающая на древесном угле. Температура внутри достигает 350–400°C — значительно выше, чем на обычной плите или газовом гриле. Это обеспечивает: мгновенную карамелизацию снаружи (корочка), сочность внутри (влага не успевает испариться), особый угольный аромат (нельзя воспроизвести в духовке). В «Парусах на крыше» хоспер используется для стейков из мраморной говядины, рёбер и рыбных блюд — это одна из гордостей кухни.",
        "list": [
          "Мраморная говядина на хоспере — стейки разных прожарок",
          "Томагавк на живом угле — кость придаёт особый вкус",
          "Рёбра на хоспере — медленное приготовление, затем финиш на огне",
          "Рыба на хоспере — дымный аромат + сочность"
        ]
      },
      {
        "heading": "Прожарка: как выбрать",
        "body": "Blue rare (почти сырое) — для ценителей, которые хотят максимум вкуса мяса. Rare (кровавое) — красный центр, тёплый. Medium rare (слабая прожарка) — розовый центр, рекомендуется для большинства стейков. Medium — чуть розовый, компромисс. Well done — полностью прожаренное — не рекомендуется для мраморного мяса: жир вытечет. Для мраморной говядины в «Парусах» рекомендуем medium rare — оптимально для раскрытия вкуса.",
        "highlight": "Если не уверены в прожарке — попросите официанта показать разрезанный стейк перед подачей. В «Парусах» это нормальная практика."
      },
      {
        "heading": "Гарниры и соусы к мясу",
        "body": "В «Парусах» к хоспер-блюдам предлагаются авторские гарниры: запечённые овощи, картофельное пюре на сливочном масле, ризотто с пармезаном. Соусы: классический беарнез, соус из ягод Северо-Запада (морошка, брусника), дореми. Правило: хороший стейк не требует тяжёлого соуса — лучший соус — мясной сок на тарелке."
      }
    ],
    "cta": {
      "text": "Заказать мясо на хоспере",
      "href": "/menu"
    }
  },
  {
    "slug": "grebyonki-grebeshki-peterburg-restoran",
    "title": "Гребешки в ресторанах Петербурга: где лучшие морские гребешки",
    "metaTitle": "Гребешки в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Морские гребешки в ресторанах Санкт-Петербурга. Где попробовать лучшие гребешки? «Паруса на крыше» — гребешки с цветной капустой и икрой, фирменное блюдо.",
    "keywords": "гребешки рестораны петербург, морские гребешки спб, гребешки ресторан петербург",
    "date": "2026-06-02",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Морские гребешки — деликатес, который в петербургских авторских ресторанах подают по-особому: не просто жареный гребешок, а продуманная комбинация вкусов и текстур.",
    "sections": [
      {
        "heading": "Почему гребешки — вершина морских деликатесов",
        "body": "Морской гребешок — двустворчатый моллюск с нежной белой мякотью и сладковатым морским вкусом. Правильно приготовленный гребешок: хрустящая корочка снаружи, нежный и полупрозрачный внутри. Неправильно — резиновый. В «Парусах на крыше» гребешки — одно из главных фирменных блюд: они готовятся точно до нужной температуры и подаются с авторскими компонентами.",
        "list": [
          "Гребешки с цветной капустой и икрой — фирменное блюдо «Парусов»",
          "Техника: быстрое обжаривание при высокой температуре",
          "Свежесть: гребешки поставляются от проверенных поставщиков",
          "Сочетание: морской вкус + кремовость цветной капусты + соль икры"
        ]
      },
      {
        "heading": "Как едят гребешки",
        "body": "Гребешки едят сразу после подачи — они быстро теряют температуру. Разрезайте поперёк или ешьте целиком (если небольшой). Вилка и нож или просто вилка — нет строгих правил. К гребешкам — бокал сухого белого или игристого: пузырьки усиливают морской вкус.",
        "highlight": "Попробуйте гребешки как первое блюдо вечера: они «открывают» вкусовые рецепторы и подготавливают к остальному меню."
      },
      {
        "heading": "Сезонность гребешков",
        "body": "Морские гребешки доступны круглый год (охлаждённые или замороженные IQF), но лучший сезон — осень-зима: гребешок нагуливается летом, к осени достигает максимального вкуса. В «Парусах» шеф отслеживает поставки и работает с наилучшим доступным продуктом."
      }
    ],
    "cta": {
      "text": "Попробовать фирменные гребешки",
      "href": "/menu"
    }
  },
  {
    "slug": "karpachcho-tatrar-restoran-peterburg",
    "title": "Карпаччо и тартар в ресторанах Петербурга: где вкуснее",
    "metaTitle": "Карпаччо и тартар в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Карпаччо и тартар в ресторанах Санкт-Петербурга. Где попробовать лучший тартар из говядины и карпаччо в авторской подаче? «Паруса на крыше».",
    "keywords": "карпаччо тартар ресторан петербург, тартар говядина спб, карпаччо ресторан петербург",
    "date": "2026-06-03",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Карпаччо и тартар — тест для кухни любого ресторана. Оба блюда готовятся из сырого мяса или рыбы и не прощают ошибок: только свежие продукты, правильный нож и точный вкус.",
    "sections": [
      {
        "heading": "Тартар в «Парусах на крыше»",
        "body": "Тартар из говядины в «Парусах» — авторская версия классического блюда. Ручная рубка (не мясорубка) сохраняет текстуру. Соус: желток, дижонская горчица, каперсы, корнишоны, несколько капель табаско — баланс кислого, острого и сочного. Подача: с хрустящими тостами или картофельными дольками. Говядина: мраморная, от проверенного поставщика, используется только свежая.",
        "list": [
          "Ручная рубка — сохраняет текстуру, не превращает в паштет",
          "Мраморная говядина — жирность даёт вкус и нежность",
          "Авторский соус — баланс кислоты, остроты и умами",
          "Подача с тостами — традиция, которая работает"
        ]
      },
      {
        "heading": "Карпаччо: разные варианты",
        "body": "Карпаччо — тончайшие слайсы сырого продукта, политые оливковым маслом с лимоном. В «Парусах» доступно несколько вариантов: карпаччо из говядины (классика), карпаччо из тунца (морской вариант), карпаччо из осьминога (авторская позиция). К каждому — своя заправка и гарнир: руккола и пармезан к говядине, каперсы и авокадо к тунцу.",
        "highlight": "Карпаччо из говядины — лучшее начало особого ужина. Лёгкое, яркое, не перегружает желудок перед горячим."
      },
      {
        "heading": "Как выбрать между тартаром и карпаччо",
        "body": "Если хотите насыщенного вкуса — тартар (рубленое мясо с соусом). Если хотите лёгкого и деликатного — карпаччо (тонкие слайсы с простой заправкой). Оба хорошо начинают ужин. Можно заказать половину тартара и карпаччо на двоих — официант обычно делает это без проблем."
      }
    ],
    "cta": {
      "text": "Заказать тартар или карпаччо",
      "href": "/menu"
    }
  },
  {
    "slug": "risotto-pasta-restoran-peterburg",
    "title": "Лучшее ризотто и паста в ресторанах Петербурга",
    "metaTitle": "Лучшее ризотто и паста в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Ризотто и паста в ресторанах Санкт-Петербурга: где вкуснее? «Паруса на крыше» — авторское ризотто с белыми грибами и сезонные пасты в меню.",
    "keywords": "ризотто ресторан петербург, паста ресторан спб, лучшее ризотто петербург",
    "date": "2026-06-03",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Ризотто и паста — блюда, по которым судят о кухне. Это не итальянский ресторан в Петербурге, а авторская интерпретация: ризотто с карельскими грибами, паста с балтийской рыбой.",
    "sections": [
      {
        "heading": "Ризотто в «Парусах»: почему оно особенное",
        "body": "Хорошее ризотто готовится 18–20 минут непрерывного помешивания — его нельзя заготовить заранее. В «Парусах» ризотто готовится à la minute (по заказу), что делает его всегда свежим. Фирменная версия: ризотто с белыми грибами и пармезаном — карельские белые грибы дают насыщенный лесной аромат, пармезан — кремовость. Подача: al dente, не суп и не каша — правильная «волна» при встряске тарелки.",
        "list": [
          "Ризотто à la minute — 18 минут после заказа",
          "Карельские белые грибы — интенсивный лесной вкус",
          "Пармезан и сливочное масло — кремовость без тяжести",
          "Сезонные варианты: ризотто с трюфелем (осень-зима)"
        ]
      },
      {
        "heading": "Паста в авторском меню",
        "body": "Паста в «Парусах» — не итальянский фастфуд, а петербургская авторская интерпретация. Варианты: паста с морепродуктами (гребешки, креветки, мидии), паста с белыми грибами (сезонный фаворит), черная паста с каракатицей (для любителей). Тесто — либо собственное (уточняйте), либо лучшего итальянского производителя.",
        "highlight": "Паста с белыми грибами осенью — одно из главных сезонных блюд. Карельские грибы в сливочном соусе с пармезаном — вкус северного леса в городском ресторане."
      },
      {
        "heading": "Как выбрать: ризотто или паста",
        "body": "Ризотто: кремовее, насыщеннее, более «обволакивающее» — идеально для холодного вечера. Паста: более текстурная, легче, ярче по вкусу — хорошо летом. Оба блюда работают как самостоятельное горячее или могут делиться на двоих (в качестве primi перед основным)."
      }
    ],
    "cta": {
      "text": "Посмотреть блюда в меню",
      "href": "/menu"
    }
  },
  {
    "slug": "supy-restoran-peterburg",
    "title": "Лучшие супы в ресторанах Петербурга: что заказывать",
    "metaTitle": "Лучшие супы в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Лучшие супы в ресторанах Санкт-Петербурга. Крем-супы, уха, рыбные бульоны. «Паруса на крыше» — авторские супы из локальных продуктов Северо-Запада.",
    "keywords": "супы рестораны петербург, крем-суп ресторан спб, уха ресторан петербург",
    "date": "2026-06-03",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Суп в авторском ресторане — это не столовое первое. Это концентрированный вкус, правильная текстура и история за каждой тарелкой.",
    "sections": [
      {
        "heading": "Супы в авторской кухне: что это значит",
        "body": "В авторском ресторане суп — полноценное блюдо с собственной концепцией. Крем-суп из тыквы с карельскими грибами: тыква карамелизируется в духовке, затем пюрируется с бульоном — получается бархатистая текстура с ореховым вкусом. Уха из лосося с гребешком: бульон варится на хребтах лосося несколько часов, затем добавляется рыба и морепродукты — это не рыбный суп, а навар из рыбы.",
        "list": [
          "Крем-суп из тыквы — сезонный осенне-зимний хит",
          "Уха из лосося с гребешком — фирменный рыбный суп",
          "Суп дня — меняется ежедневно в зависимости от продуктов",
          "Холодный суп (гаспаччо, свекольник) — летний вариант"
        ]
      },
      {
        "heading": "Суп как часть ланча",
        "body": "В бизнес-ланч «Парусов» от 590 ₽ входит суп или закуска — это основа обеденного меню. Суп дня — лучший способ попробовать, что сегодня на кухне: шеф готовит из лучших доступных продуктов. Порция: полная тарелка, не «дегустационная» — можно наесться.",
        "highlight": "Суп дня в «Парусах» — лучший выбор при бизнес-ланче. Меняется ежедневно, всегда из свежих продуктов. Спросите официанта что сегодня."
      },
      {
        "heading": "Уха vs. рыбный суп: в чём разница",
        "body": "Уха — традиционное русское рыбное блюдо: прозрачный насыщенный бульон с рыбой и минимумом других ингредиентов. Рыбный суп (биск, буйабес, похлёбка) — западная традиция, более насыщенная, часто со сливками. В «Парусах» уха приготовлена в русской традиции с авторскими деталями: гребешок делает вкус глубже, а подача — более современной."
      }
    ],
    "cta": {
      "text": "Попробовать авторские супы",
      "href": "/menu"
    }
  },
  {
    "slug": "deserty-tort-avtor-peterburg",
    "title": "Лучшие десерты в ресторанах Петербурга: где вкуснее всего",
    "metaTitle": "Лучшие десерты в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Лучшие десерты в ресторанах Санкт-Петербурга. Авторские торты, паннакота, шоколадный фондан. «Паруса на крыше» — десерты от шеф-кондитера.",
    "keywords": "лучшие десерты рестораны петербург, авторский торт ресторан спб, десерты ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Десерт в хорошем ресторане — не «что-нибудь сладкое в конце», а самостоятельное произведение. Авторский десерт от шеф-кондитера говорит о том, что кухня серьёзная.",
    "sections": [
      {
        "heading": "Авторские десерты «Парусов»",
        "body": "В «Парусах на крыше» десерты создаются шеф-кондитером ресторана. Они меняются сезонно и включают как классику в авторском исполнении, так и оригинальные позиции. Стабильные фавориты: торт «Птичье молоко» в авторской версии (легче и нежнее классики), шоколадный фондан (жидкий центр при правильной температуре подачи), паннакота с сезонными ягодами Северо-Запада.",
        "list": [
          "Торт «Птичье молоко» — классика в авторской интерпретации",
          "Шоколадный фондан — горячий, жидкий центр при подаче",
          "Паннакота с морошкой или брусникой — северный акцент",
          "Сорбе из сезонных ягод — лёгкий летний вариант"
        ]
      },
      {
        "heading": "Десерт на торжество",
        "body": "При особом поводе — день рождения, годовщина, предложение — шеф-кондитер готовит именной торт с надписью. Это заказывается при бронировании за 2–3 дня. Стандартная опция: небольшой торт на 4–6 порций с именем и датой. Альтернатива: торт на весь стол с тематическим оформлением — обсуждается отдельно.",
        "highlight": "Торт с надписью от шефа: закажите при бронировании за 2–3 дня. Это входит в концепцию особого вечера и не требует дополнительных затрат."
      },
      {
        "heading": "Горячий десерт или холодный: что выбрать",
        "body": "Горячие (фондан, штрудель): дают ощущение уюта, особенно зимой. Лучше всего как финальный аккорд осенне-зимнего ужина. Холодные (паннакота, сорбе, тарт): освежают, не перегружают. Хорошо летом или после сытного горячего. Правило: если закончили тяжёлое мясное блюдо — возьмите что-то лёгкое. После рыбы — можно и фондан."
      }
    ],
    "cta": {
      "text": "Попробовать авторские десерты",
      "href": "/menu"
    }
  },
  {
    "slug": "kokteyly-bar-restoran-peterburg",
    "title": "Коктейли и барная карта в ресторанах Петербурга",
    "metaTitle": "Коктейли и барная карта ресторанов Петербурга — Паруса на крыше",
    "metaDescription": "Коктейли и барная карта в ресторанах Санкт-Петербурга. Что пить? Авторские коктейли, вина, алкоголь. «Паруса на крыше» — авторская барная карта.",
    "keywords": "коктейли ресторан петербург, барная карта ресторан спб, что пить ресторан петербург",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Барная карта хорошего ресторана — такая же история, как кухня. Авторские коктейли, правильно подобранное вино, местные дистилляты — это часть гастрономического опыта.",
    "sections": [
      {
        "heading": "Авторские коктейли «Парусов»",
        "body": "В «Парусах на крыше» барная карта включает как классику, так и авторские позиции, разработанные барменом специально для ресторана. Направление: петербургские коктейли — с локальными дистиллятами, ягодными настоями и нестандартными ингредиентами. Безалкогольные коктейли: отдельная линейка для тех, кто не пьёт — не просто сок, а полноценные напитки с балансом вкусов.",
        "list": [
          "Авторские коктейли на петербургских дистиллятах",
          "Ягодные настои из Северо-Запада: морошка, брусника",
          "Безалкогольная линейка — лимонады и коктейли",
          "Аперитив и дижестив — вечер начинается и заканчивается правильно"
        ]
      },
      {
        "heading": "Карта вин: что выбрать",
        "body": "Карта вин «Парусов» составлена с прицелом на разнообразие и хорошую сочетаемость с меню. Белые: совиньон блан, шабли, пино гри — к рыбе и морепродуктам. Красные: пино нуар, мальбек, каберне — к мясным блюдам. Игристые: шампань и просекко для аперитива. Грузинские вина: отдельная секция — оранж и натуральные вина. Рекомендация: доверяйте официанту — они хорошо знают карту и могут порекомендовать конкретную бутылку под ваш выбор блюд.",
        "highlight": "Бокал вина к ужину: лучший совет — расскажите официанту, что закажете из еды, и попросите подобрать вино. Это называется «паринг» и работает лучше самостоятельного выбора."
      },
      {
        "heading": "Алкоголь без алкоголя: тренд 2026",
        "body": "Всё больше гостей предпочитают безалкогольный вечер. В «Парусах» для этого есть авторские лимонады (имбирный, цитрусовый, ягодный), холодные чаи с фруктами, морсы и безалкогольный сидр. Ни один из них не выглядит как «просто сок» — это полноценные напитки с характером."
      }
    ],
    "cta": {
      "text": "Посмотреть барную карту",
      "href": "/menu"
    }
  },
  {
    "slug": "vino-restoran-spb-rekomendatsii",
    "title": "Вино в ресторанах Петербурга: как выбрать правильно",
    "metaTitle": "Вино в ресторанах Петербурга — как выбрать | Паруса на крыше",
    "metaDescription": "Как выбрать вино в ресторане Санкт-Петербурга? Советы по подбору вина к блюдам. «Паруса на крыше» — разнообразная карта вин, помощь сомелье.",
    "keywords": "вино ресторан петербург советы, как выбрать вино ресторан спб, карта вин петербург ресторан",
    "date": "2026-06-04",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "Выбор вина в ресторане кажется сложным, но это не так. Несколько правил и доверие официанту — и вечер с правильным вином превращается в гастрономическое путешествие.",
    "sections": [
      {
        "heading": "Основные правила сочетания вина с едой",
        "body": "Золотые правила: к рыбе и морепродуктам — белое или розовое сухое. К мясу — красное (пино нуар к лёгкому мясу, каберне к стейку). К сыру — зависит от типа сыра: к мягким белое, к твёрдым — красное. К десерту — полусладкое или игристое. В «Парусах» карта вин составлена с учётом меню — сочетания продуманы заранее.",
        "list": [
          "Рыба, морепродукты → белое сухое (шабли, совиньон блан)",
          "Стейк, мясо на хоспере → красное (каберне, мальбек)",
          "Аперитив → игристое (просекко, шампань)",
          "Десерт → мускат или просекко"
        ]
      },
      {
        "heading": "Как заказывать вино без страха",
        "body": "Лучшая стратегия: расскажите официанту, что будете есть, и попросите подобрать бокал или бутылку. Скажите бюджет (это нормально: «что-то около 2 000–3 000 ₽ за бутылку»). Если хочется попробовать что-то новое — попросите «что-нибудь интересное из карты, чего я раньше не пробовал». Хороший ресторан имеет персонал, который любит вино и умеет объяснить.",
        "highlight": "Рекомендуем попробовать грузинское оранжевое вино — если его нет в карте, спросите официанта об альтернативах. Это нетипично и очень интересно."
      },
      {
        "heading": "Вино на особый вечер",
        "body": "Для особого вечера (день рождения, предложение): бутылка шампанского — universal choice. Для длинного ужина: начните с белого (к закускам), перейдите на красное (к основному). Для быстрого ужина: один бокал к горячему блюду — не перегружайте вечер."
      }
    ],
    "cta": {
      "text": "Выбрать вино с помощью официанта",
      "href": "/menu"
    }
  },
  {
    "slug": "khosper-myaso-vid-peterburg",
    "title": "Ужин с мясом на хоспере и видом на Петербург",
    "metaTitle": "Ужин с мясом на хоспере и видом на Петербург — Паруса на крыше",
    "metaDescription": "Мясо на хоспере с видом на Санкт-Петербург. «Паруса на крыше» — стейки и мясо на живом угле с панорамой исторического центра. Бронирование.",
    "keywords": "хоспер вид петербург ресторан, стейк вид петербург, ужин хоспер вид город",
    "date": "2026-06-05",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Сочетание: стейк на хоспере + закат над Петербургом за окном. Это не просто ужин — это опыт, который трудно забыть.",
    "sections": [
      {
        "heading": "Почему хоспер и вид — идеальная пара",
        "body": "Стейк на хоспере требует времени (18–25 минут) — и это время лучше всего проводить, глядя на Петербург. Пока готовится мясо, вы сидите за бокалом вина, смотрите как меняется свет над Казанским собором — и к приходу горячего уже достигли нужного расслабленного состояния. В «Парусах» это работает именно так.",
        "list": [
          "Хоспер-блюда готовятся 15–25 минут — есть время насладиться видом",
          "Аромат угля из кухни — неотъемлемая часть ресторана",
          "Стейк подаётся горячим, на тарелке с соком — в идеальный момент",
          "Вид на закат = натуральный таймер для ужина"
        ]
      },
      {
        "heading": "Что заказывать с мясом",
        "body": "К стейку на хоспере: начните с лёгкой закуски (карпаччо или тартар), чтобы не перегрузить вкусовые рецепторы. Гарнир: картофельное пюре или запечённые овощи. Вино: красное, не слишком таниновое — мальбек или риоха. Десерт: что-то лёгкое после сытного горячего — паннакота или сорбе.",
        "highlight": "Идеальный тайминг: закажите аперитив, пока готовится мясо. 20 минут с бокалом игристого и видом на Петербург — лучшее начало вечера."
      },
      {
        "heading": "Как бронировать под мясной ужин",
        "body": "Бронировать заранее и указать предпочтение к стейку при бронировании необязательно — меню достаточно разнообразное. Но если хотите конкретный столик у окна с видом на закат плюс мясной ужин — бронируйте за 3–5 дней с пометкой."
      }
    ],
    "cta": {
      "text": "Забронировать мясной ужин с видом",
      "href": "/"
    }
  },
  {
    "slug": "zavtrak-restoran-peterburg",
    "title": "Завтраки в ресторанах Петербурга: где вкусный завтрак",
    "metaTitle": "Завтраки в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Вкусные завтраки в ресторанах Санкт-Петербурга. Где позавтракать с видом на город? «Паруса на крыше» — завтраки в выходные с видом на Петербург.",
    "keywords": "завтрак ресторан петербург, вкусный завтрак спб, завтрак с видом петербург",
    "date": "2026-06-05",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Завтрак с видом на Петербург — особый опыт. Утренний город, кофе и авторская кухня — лучшее начало дня в любом сезоне.",
    "sections": [
      {
        "heading": "Завтраки в «Парусах»: когда и что",
        "body": "«Паруса на крыше» предлагают завтраки в выходные (уточняйте актуальное расписание при бронировании). Утреннее меню: авторские яйца бенедикт, омлет с локальными продуктами, авторские каши и блинчики, свежие соки и кофе. Всё с видом на утренний Петербург — Казанский собор в утреннем свете, крыши в дымке, небо над городом.",
        "list": [
          "Яйца бенедикт — классика в авторском исполнении",
          "Омлет с грибами или морепродуктами — сытный вариант",
          "Авторские блинчики с ягодами — лёгкий вариант",
          "Кофе specialty — зерна от петербургских обжарщиков"
        ]
      },
      {
        "heading": "Завтрак как часть петербургского выходного",
        "body": "Идеальный выходной в Петербурге: поздний завтрак в «Парусах» в 10:00–12:00 → прогулка по утреннему городу (до толп туристов) → обед или кофе в кофейне → вечерняя прогулка. Завтрак с видом на Петербург — это не просто еда, это точка отсчёта хорошего дня.",
        "highlight": "Для завтрака в выходные рекомендуем бронировать — столики у окна разбирают быстро. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Что делает завтрак «авторским»",
        "body": "В обычном кафе: яичница и кофе. В авторском ресторане: яйца бенедикт с карельскими грибами и соусом из северных ягод + кофе из свежеобожженных зёрен. Разница — в деталях: качество продукта, точность приготовления и сервировка. Завтрак в «Парусах» — это первое блюдо дня, которое задаёт планку всему остальному."
      }
    ],
    "cta": {
      "text": "Забронировать завтрак с видом",
      "href": "/"
    }
  },
  {
    "slug": "sezonnoe-menyu-restoran-peterburg",
    "title": "Сезонное меню в ресторанах Петербурга: что есть когда",
    "metaTitle": "Сезонное меню в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Сезонное меню в ресторанах Санкт-Петербурга. Что есть в каждое время года? «Паруса на крыше» — меню обновляется 4 раза в год, сезонные продукты Северо-Запада.",
    "keywords": "сезонное меню ресторан петербург, что есть зимой весной осенью ресторан спб, сезонные блюда ресторан",
    "date": "2026-06-05",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Сезонная кухня — это когда ресторан следует природе, а не складским запасам. Блюда меняются с временем года, и каждый визит — новый гастрономический опыт.",
    "sections": [
      {
        "heading": "Почему сезонность важна",
        "body": "Сезонный продукт на пике: корюшка в апреле (только тогда!), белые грибы в августе-сентябре, клюква осенью. Вне сезона тот же продукт — замороженный или привозной — не даёт того вкуса. Ресторан, работающий по сезону, даёт гарантию: вы едите лучший продукт в лучшее его время. В «Парусах» меню обновляется 4 раза в год с учётом сезонности Северо-Запада.",
        "list": [
          "Весна (апрель–май): корюшка, первая зелень, весенние грибы",
          "Лето (июнь–август): ягоды, свежие овощи, лёгкие блюда",
          "Осень (сентябрь–ноябрь): белые грибы, рыба, корнеплоды, тыква",
          "Зима (декабрь–март): выдержанные сорта, морепродукты, согревающие блюда"
        ]
      },
      {
        "heading": "Что попробовать в каждый сезон",
        "body": "Весна: обязательно корюшка (если в меню) — это петербургская традиция. Лето: морепродукты, лёгкие пасты, ягодные десерты. Осень: грибное ризотто, рыбные горячие блюда, тыквенный суп. Зима: хоспер-блюда, крем-супы, шоколадный фондан. Спросите официанта, что сейчас сезонное — этот вопрос всегда приветствуется в «Парусах».",
        "highlight": "Секрет: в «Парусах» есть «блюдо дня», которое не всегда есть в основном меню — это самый свежий и сезонный выбор кухни на сегодня. Спрашивайте официанта."
      },
      {
        "heading": "Как следить за обновлениями меню",
        "body": "Меню «Парусов» доступно на сайте ресторана — оно обновляется при смене сезона. Следите за социальными сетями ресторана: шеф анонсирует новые блюда и сезонные позиции. Или просто спросите при бронировании: «Что сейчас в сезоне?» — получите актуальный ответ."
      }
    ],
    "cta": {
      "text": "Посмотреть актуальное меню",
      "href": "/menu"
    }
  },
  {
    "slug": "menu-biznes-lanch-peterburg-sostav",
    "title": "Что входит в бизнес-ланч: состав и цены в Петербурге",
    "metaTitle": "Что входит в бизнес-ланч в Петербурге — состав и цены | Паруса",
    "metaDescription": "Что включает бизнес-ланч в ресторанах Санкт-Петербурга? Состав, цены, варианты. «Паруса на крыше» — бизнес-ланч от 590 ₽ с авторской кухней.",
    "keywords": "что входит в бизнес-ланч петербург, состав бизнес-ланч спб, бизнес-ланч цены петербург",
    "date": "2026-06-06",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Бизнес-ланч — стандартное предложение большинства ресторанов. Но что конкретно входит, сколько стоит и почему это выгодно — разбираем честно.",
    "sections": [
      {
        "heading": "Стандартный состав бизнес-ланча",
        "body": "Классический бизнес-ланч в ресторане Петербурга: суп или закуска (1 позиция) + горячее блюдо (1 позиция) + напиток (чай или кофе, иногда морс). Иногда добавляется хлеб. В «Парусах на крыше» бизнес-ланч от 590 ₽ включает суп или закуску из авторской кухни + горячее + напиток. Это полноценный обед с блюдами того же уровня, что à la carte вечером.",
        "list": [
          "590 ₽ — суп или закуска + горячее + напиток",
          "Авторская кухня, не упрощённая «столовая» версия",
          "Блюда меняются ежедневно — разнообразие при регулярных визитах",
          "Время: 12:00–16:00, будние дни"
        ]
      },
      {
        "heading": "Почему бизнес-ланч выгоднее à la carte",
        "body": "Те же блюда вечером: суп 400–600 ₽ + горячее 700–1 200 ₽ + напиток 200–400 ₽ = 1 300–2 200 ₽. Бизнес-ланч: 590 ₽. Экономия: 55–75% при том же уровне кухни. Вывод: бизнес-ланч в «Парусах» — лучший способ регулярно есть в хорошем ресторане с видом на Петербург без нагрузки на бюджет.",
        "highlight": "Регулярный бизнес-ланч в «Парусах» — это 590 ₽ за обед с видом на Казанский собор. Дешевле многих сетевых кафе, но с авторской кухней."
      },
      {
        "heading": "Как лучше использовать бизнес-ланч",
        "body": "Первый визит: приходите на бизнес-ланч, чтобы оценить кухню без лишних трат. Регулярный обед: бронируйте один-два раза в неделю — официант запомнит предпочтения. Деловая встреча: бизнес-ланч — отличный формат для коротких деловых встреч (45–60 минут). Просто пауза в рабочем дне: 1 час в ресторане с видом на Петербург — лучший способ перезарядиться."
      }
    ],
    "cta": {
      "text": "Попробовать бизнес-ланч от 590 ₽",
      "href": "/menu"
    }
  },
  {
    "slug": "veganskoe-menu-restoran-peterburg",
    "title": "Вегетарианские и веганские блюда в ресторанах Петербурга",
    "metaTitle": "Вегетарианское меню в ресторанах Петербурга — Паруса на крыше",
    "metaDescription": "Вегетарианские и веганские блюда в ресторанах Санкт-Петербурга. Где поесть вегетарианцу? «Паруса на крыше» — растительные опции в авторском меню.",
    "keywords": "вегетарианское меню ресторан петербург, веган ресторан спб, растительное меню петербург",
    "date": "2026-06-06",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Вегетарианец или веган в хорошем ресторане — не проблема, если кухня хорошая. Авторский шеф умеет работать с растительными ингредиентами так, что они не выглядят как «гарнир без мяса».",
    "sections": [
      {
        "heading": "Растительные блюда в меню «Парусов»",
        "body": "В «Парусах» вегетарианские блюда — не выделенный раздел меню, а интегрированные позиции. Типичные вегетарианские варианты: ризотто с белыми грибами и пармезаном (строгим веганам — без пармезана по запросу), паста с сезонными овощами, авторские закуски на основе овощей и грибов, суп дня (часто без мяса — уточняйте у официанта), десерты.",
        "list": [
          "Ризотто с белыми грибами — без мяса и морепродуктов",
          "Паста с сезонными овощами — варьируется по сезону",
          "Авторские салаты — основа из свежих и ферментированных овощей",
          "Десерты — большинство без мяса, несколько без яиц"
        ]
      },
      {
        "heading": "Как заказывать вегетарианцу в ресторане",
        "body": "Лучшая стратегия: скажите официанту «я вегетарианец» при заказе — хорошая кухня адаптирует блюда. Уточните: что конкретно исключить (мясо, рыбу, морепродукты, яйца, молочное). Спросите о блюде дня — часто шеф готовит что-то сезонное, которого нет в основном меню. В «Парусах» кухня гибкая — адаптация возможна.",
        "highlight": "Веганам рекомендуем позвонить при бронировании и предупредить — кухня подготовит адаптированные варианты из сезонных продуктов."
      },
      {
        "heading": "Тренд: растительная кухня в 2026",
        "body": "В 2026 году «растительная кухня» — это не про ограничения, а про открытия. Белые грибы, ферментированные овощи, северные ягоды, микрозелень, морошка — всё это интересные растительные ингредиенты с насыщенным вкусом. Авторская кухня «Парусов» работает с этими продуктами, создавая блюда, интересные и мясоедам."
      }
    ],
    "cta": {
      "text": "Уточнить вегетарианские опции",
      "href": "/menu"
    }
  },
  {
    "slug": "bannoe-menu-spb-stoimost",
    "title": "Банкетное меню в ресторанах СПб: состав и стоимость",
    "metaTitle": "Банкетное меню в ресторанах СПб — состав и стоимость | Паруса на крыше",
    "metaDescription": "Банкетное меню в ресторанах Санкт-Петербурга: что входит и сколько стоит. «Паруса на крыше» — банкетное меню от 2 500 ₽/чел. для событий до 300 гостей.",
    "keywords": "банкетное меню ресторан спб, стоимость банкетного меню петербург, что входит банкетное меню",
    "date": "2026-06-06",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Банкетное меню — фиксированный набор блюд по цене на человека. Как его выбрать, что должно входить и на что обратить внимание — разбираем без маркетинга.",
    "sections": [
      {
        "heading": "Что входит в банкетное меню",
        "body": "Стандартный состав банкетного меню в хорошем ресторане: холодные закуски (2–4 позиции на стол), горячие закуски (1–2), горячее блюдо (1–2 варианта на выбор), гарниры, хлеб, десерт или торт. Напитки (алкоголь) — обычно отдельно. В «Парусах на крыше» банкетное меню от 2 500 ₽/чел. включает несколько блюд из авторской кухни — закуски, горячее, десерт. Алкоголь по карте вин дополнительно.",
        "list": [
          "От 2 500 ₽/чел. — базовое банкетное меню",
          "Несколько вариантов на разные бюджеты",
          "Закуски, горячее, десерт — в стоимости",
          "Алкоголь — по карте, дополнительно"
        ]
      },
      {
        "heading": "Как выбирать банкетное меню",
        "body": "На что обратить внимание: разнообразие — есть ли опции для разных вкусов (мясное и рыбное горячее). Количество перемен блюд — 3–4 перемены для ужина на 3–4 часа это нормально. Адаптация — можно ли исключить что-то для вегетарианцев? В «Парусах» при согласовании банкетного меню всё это обсуждается с менеджером.",
        "highlight": "Дегустация банкетного меню: попросите организовать её до подписания договора. Хороший ресторан обычно предлагает это бесплатно или с минимальной оплатой."
      },
      {
        "heading": "Как рассчитать бюджет банкета",
        "body": "Формула: банкетное меню × количество гостей + алкоголь (≈ 30–40% от стоимости еды) + программа (если есть). Пример: 2 500 ₽ × 40 гостей = 100 000 ₽ за еду + 35 000–40 000 ₽ на алкоголь = 135 000–140 000 ₽ базовый бюджет. При добавлении ведущего и живой музыки: +50 000–100 000 ₽."
      }
    ],
    "cta": {
      "text": "Обсудить банкетное меню",
      "href": "/banket"
    }
  },
  {
    "slug": "lanch-panoramnom-restorane-spb",
    "title": "Ланч в панорамном ресторане Петербурга: как это выглядит",
    "metaTitle": "Ланч в панорамном ресторане Петербурга — Паруса на крыше",
    "metaDescription": "Как выглядит ланч в панорамном ресторане Петербурга? «Паруса на крыше» — бизнес-ланч от 590 ₽ с видом на Казанский собор и крыши исторического центра.",
    "keywords": "ланч панорамный ресторан петербург, обед вид петербург, бизнес-ланч вид петербург",
    "date": "2026-06-06",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Обед в панорамном ресторане — это не просто обед. За 45 минут и 590 рублей вы получаете ужин с видом, который петербуржцы называют лучшей «паузой в рабочем дне».",
    "sections": [
      {
        "heading": "Что такое ланч в «Парусах на крыше»",
        "body": "«Паруса на крыше» предлагают бизнес-ланч в будние дни с 12:00 до 16:00, начиная от 590 ₽. Это включает: суп или закуску из авторской кухни + горячее + напиток. Всё это происходит на 6-м этаже Olympic Plaza с панорамой исторического центра Петербурга за окном. В 12:30 дневной свет на куполах Казанского собора — идеальный вид для обеденного перерыва.",
        "list": [
          "От 590 ₽ — полный обед с авторской кухней",
          "12:00–16:00 будние дни — гибкое окно для перерыва",
          "Вид на Казанский собор и крыши — дневной свет",
          "Средний время визита: 40–60 минут"
        ]
      },
      {
        "heading": "Как выглядит стандартный ланч",
        "body": "Вы поднимаетесь на 6-й этаж Olympic Plaza. Хостес провожает к столу. Официант приносит меню бизнес-ланча — 3–4 варианта супа и горячего. Заказываете, блюдо приносят за 10–15 минут. Вы едите с видом на Петербург. Выходите через 45–55 минут. Счёт: 590–800 ₽ в зависимости от выбора. Именно так работает «лучший обеденный перерыв в городе» — по словам постоянных гостей.",
        "highlight": "Пиковое время: 13:00–14:00. Для спокойного обеда без очереди приходите до 12:30 или после 14:30."
      },
      {
        "heading": "Стоит ли бронировать ланч",
        "body": "На большинство будних дней бронь не нужна — мест достаточно. Исключения: пятница, праздники, если хотите конкретный столик у окна. В таких случаях звоните заранее: +7 (812) 991-10-90."
      }
    ],
    "cta": {
      "text": "Попробовать бизнес-ланч",
      "href": "/menu"
    }
  },
  {
    "slug": "uzhin-dlya-dvoyh-chto-zakazat",
    "title": "Что заказать на ужин для двоих в ресторане: советы",
    "metaTitle": "Что заказать на ужин для двоих в ресторане — советы | Паруса",
    "metaDescription": "Как заказать идеальный ужин для двоих в ресторане? Советы по выбору блюд, напитков и порядку подачи. «Паруса на крыше» — авторское меню для особого вечера.",
    "keywords": "что заказать ужин для двоих ресторан, ужин двоих меню советы, романтический ужин что заказать",
    "date": "2026-06-07",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Ужин для двоих в хорошем ресторане — ритуал, у которого есть своя драматургия. Правильный порядок блюд превращает обычный вечер в гастрономическое путешествие.",
    "sections": [
      {
        "heading": "Структура идеального ужина для двоих",
        "body": "Классическая структура романтического ужина: аперитив (игристое или авторский коктейль, пока выбираете блюда), холодная закуска на двоих (делится, создаёт контакт — попробуйте, передайте), горячее (каждый своё или одно на двоих — зависит от отношений), десерт (обязательно, это финальный аккорд). Итого: 2,5–3 часа, не торопитесь.",
        "list": [
          "Аперитив: шампанское или авторский коктейль — начало",
          "Закуска на двоих: гребешки или карпаччо — интерактивно",
          "Горячее: каждый своё — создаёт разнообразие для разговора",
          "Десерт: авторский — финальный «поцелуй» ужина"
        ]
      },
      {
        "heading": "Что заказать конкретно в «Парусах»",
        "body": "Рекомендуемое меню для двоих: аперитив — бокал просекко или авторский коктейль (400–700 ₽/бокал). Закуска — гребешки на двоих (600–900 ₽) или карпаччо. Горячее — стейк на хоспере + рыбное блюдо (попробуете оба вида). Десерт — авторский торт или шоколадный фондан. Итого за еду: 3 000–5 000 ₽ на двоих.",
        "highlight": "Секрет: закажите один десерт на двоих — это создаёт момент близости и не перегружает желудок. Официант принесёт две ложки."
      },
      {
        "heading": "Вино к ужину для двоих",
        "body": "Оптимально: бутылка вина на двоих на весь вечер. Для начала — белое к закускам, потом допейте красное к горячему — или возьмите две бутылки по бокалу. Бюджет: хорошее вино 1 500–3 000 ₽/бутылка. Попросите официанта — он помогает с выбором под конкретное меню."
      }
    ],
    "cta": {
      "text": "Забронировать ужин для двоих",
      "href": "/romanticheskiy-uzhin"
    }
  },
  {
    "slug": "luchshaya-ryba-morskoy-produkt-peterburg",
    "title": "Лучшие морепродукты Петербурга: что и где пробовать",
    "metaTitle": "Лучшие морепродукты Петербурга — что и где | Паруса на крыше",
    "metaDescription": "Лучшие морепродукты в ресторанах Санкт-Петербурга. Гребешки, устрицы, крабы, рыба. «Паруса на крыше» — авторские морепродукты с видом на Петербург.",
    "keywords": "морепродукты петербург лучшие, где морепродукты петербург ресторан, устрицы крабы петербург ресторан",
    "date": "2026-06-07",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Петербург — портовый город с традицией морской кухни. Гребешки, устрицы, краб, балтийская рыба — всё это часть петербургской гастрономии. Разбираем, что и где попробовать.",
    "sections": [
      {
        "heading": "Морская карта Петербурга",
        "body": "Топ морепродуктов для пробы в Петербурге: Гребешок морской — самый доступный и вкусный деликатес, лучший вариант для знакомства с морепродуктами. Устрица — сезонный деликатес (осень-весна), для любителей. Краб — камчатский или стригун, дорого но стоит. Корюшка (апрель-май) — петербургская рыба, уличная и ресторанная. Балтийская треска — основа петербургской рыбной кухни. В «Парусах на крыше» регулярно представлены гребешок и балтийская рыба, сезонно — другие морепродукты.",
        "list": [
          "Гребешок — фирменное блюдо «Парусов», лучшая точка входа",
          "Балтийская рыба: треска, лосось, корюшка (сезонно)",
          "Сезонные морепродукты: уточняйте у официанта",
          "Авторские сочетания: морепродукты + северные ягоды"
        ]
      },
      {
        "heading": "Как определить свежесть морепродуктов",
        "body": "Свежая рыба: глаза ясные (не мутные), жабры красные, запах морской (не «рыбный»). Свежие моллюски (устрицы, гребешки): плотные, пахнут морем. В хорошем ресторане вам не нужно проверять — репутация заведения гарантирует качество. Рейтинг 5,0 при 2 606 отзывах означает, что качество морепродуктов у «Парусов» стабильно высокое.",
        "highlight": "Не знаете с чего начать? Закажите гребешки — это идеальный вход в мир морепродуктов: нежные, без сильного запаха, в авторской подаче."
      },
      {
        "heading": "Ценовой диапазон морепродуктов",
        "body": "Корюшка (в сезон): 400–600 ₽ за порцию. Гребешки: 800–1 400 ₽. Устрицы (за штуку): 300–600 ₽. Краб: 1 500–3 000 ₽+ за порцию. Балтийская рыба: 700–1 200 ₽. В «Парусах» цены соответствуют рыночным для авторского ресторана Петербурга."
      }
    ],
    "cta": {
      "text": "Попробовать морепродукты в «Парусах»",
      "href": "/menu"
    }
  },
  {
    "slug": "menyu-restoran-peterburg-tseny",
    "title": "Меню ресторана в Петербурге: что сколько стоит в 2026",
    "metaTitle": "Меню ресторана в Петербурге — цены 2026 | Паруса на крыше",
    "metaDescription": "Цены в меню ресторана Петербурга 2026. Сколько стоят блюда в хорошем ресторане? «Паруса на крыше» — блюда от 490 ₽, средний чек ≈ 1 300 ₽.",
    "keywords": "меню ресторан петербург цены 2026, сколько стоит поесть ресторан спб, цены ресторан центр петербург",
    "date": "2026-06-07",
    "category": "Кухня и меню",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Сколько стоит поужинать в хорошем ресторане Петербурга в 2026 году? Честный разбор по категориям блюд и форматам посещения.",
    "sections": [
      {
        "heading": "Ценовой диапазон в «Парусах на крыше»",
        "body": "Блюда à la carte: закуски — 400–900 ₽, супы — 400–700 ₽, горячее — 700–1 800 ₽, десерты — 350–700 ₽. Средний чек на человека без алкоголя: 1 200–1 500 ₽. С бокалом вина: 1 700–2 200 ₽. Бизнес-ланч от 590 ₽ (будни 12:00–16:00). Банкетное меню от 2 500 ₽/чел.",
        "list": [
          "Бизнес-ланч: 590 ₽ — закуска/суп + горячее + напиток",
          "Закуска: 400–900 ₽",
          "Горячее: 700–1 800 ₽",
          "Средний чек: ≈ 1 300 ₽/чел. без алкоголя"
        ]
      },
      {
        "heading": "Как вписаться в бюджет",
        "body": "Для бюджета до 1 500 ₽/чел.: суп (400 ₽) + горячее (700–900 ₽) + чай (200 ₽) = 1 300–1 500 ₽. Для бюджета 2 000–3 000 ₽/чел.: закуска + горячее + десерт + бокал вина. Для банкета: фиксированный бюджет в 2 500 ₽/чел. — прозрачно и предсказуемо.",
        "highlight": "Совет по экономии: бизнес-ланч в «Парусах» даёт тот же уровень кухни за 590 ₽. Это лучший способ посещать хороший ресторан с видом регулярно."
      },
      {
        "heading": "Сравнение с рынком",
        "body": "Средний чек 1 300 ₽ для авторского ресторана с панорамным видом в историческом центре Петербурга — это хорошее соотношение. Для сравнения: рестораны на Невском со схожей кухней, но без вида — 1 500–2 000 ₽. Рестораны с видом в отелях — 2 500–4 000 ₽. «Паруса» выигрывают по ценовой категории в своём классе. Подробнее — в статье <a href=\"/blog/restorany-cena-kachestvo-spb\" class=\"underline text-accent\">рестораны с хорошим соотношением цена/качество</a>."
      }
    ],
    "cta": {
      "text": "Посмотреть актуальное меню",
      "href": "/menu"
    }
  },
  {
    "slug": "lokalnyye-produkty-severo-zapad-kukhnya",
    "title": "Локальные продукты Северо-Запада в петербургской кухне",
    "metaTitle": "Локальные продукты Северо-Запада в кухне Петербурга — Паруса",
    "metaDescription": "Локальные продукты Северо-Запада России в петербургской авторской кухне. Балтийская рыба, карельские грибы, новгородские ягоды. «Паруса на крыше».",
    "keywords": "локальные продукты северо-запад кухня, карельские грибы ресторан петербург, северо-запад гастрономия",
    "date": "2026-06-08",
    "category": "Кухня и меню",
    "readTime": 6,
    "image": "/photos/food.webp",
    "lead": "Северо-Запад России — богатейший гастрономический регион. Балтийское море, Ладога, карельские леса, новгородские поля — каждый из них даёт уникальные продукты, которые становятся основой петербургской авторской кухни.",
    "sections": [
      {
        "heading": "Продукты Северо-Запада в меню «Парусов»",
        "body": "Балтийская рыба: треска, балтийский лосось, корюшка (апрель-май). Карельские грибы: белые, лисички, подберёзовики — лесные ароматы в авторских блюдах. Новгородские ягоды: морошка, брусника, клюква — используются в соусах и десертах. Ленинградские фермерские продукты: молочные, мясные, овощные — прямые поставки. Это не маркетинговые заявления, а реальная основа меню, которую шеф строит из года в год.",
        "list": [
          "Балтийская рыба: треска и лосось круглый год",
          "Карельские белые грибы: август–сентябрь — пик сезона",
          "Морошка: редкий северный деликатес в соусах и десертах",
          "Фермерское мясо из Ленинградской области"
        ]
      },
      {
        "heading": "Почему локальность — это ценность",
        "body": "Локальные продукты свежее импортных: меньше времени в транспорте. Поддерживают местных производителей: ферм, рыбаков, сборщиков. Дают уникальный вкус региона: карельский гриб не похож на итальянский. Создают связь с местом: ужин в Петербурге из петербургских продуктов — это аутентичный опыт.",
        "highlight": "Тест: если официант не может объяснить, откуда продукт в блюде — возможно, локальность только на словах. В «Парусах» шеф знает поставщиков по именам."
      },
      {
        "heading": "Гид по продуктам сезона",
        "body": "Апрель-май: корюшка (единственное время). Июнь-август: балтийская рыба, морошка, ягоды. Август-сентябрь: карельские грибы — пик. Октябрь-ноябрь: лосось, брусника, клюква, тыква. Декабрь-март: выдержанные продукты, ферментированное, заготовки. Следите за сезоном — и каждый визит в «Паруса» будет гастрономически уникальным."
      }
    ],
    "cta": {
      "text": "Попробовать кухню Северо-Запада",
      "href": "/menu"
    }
  },
  {
    "slug": "kukhnya-peterburg-traditsii-kak-est",
    "title": "Петербургская кухня: традиции и что попробовать гостю",
    "metaTitle": "Петербургская кухня — традиции и что попробовать | Паруса на крыше",
    "metaDescription": "Петербургская кухня: традиции, блюда и рестораны. Что обязательно попробовать в Санкт-Петербурге? «Паруса на крыше» — авторская петербургская кухня.",
    "keywords": "петербургская кухня традиции, что попробовать петербург еда, блюда петербурга ресторан",
    "date": "2026-06-08",
    "category": "Кухня и меню",
    "readTime": 7,
    "image": "/photos/food.webp",
    "lead": "Петербургская кухня — это не отдельная «национальная» традиция, а исторический синтез. Европейские влияния, рыбацкие традиции Балтики и северная природа создали уникальный гастрономический характер.",
    "sections": [
      {
        "heading": "Что такое петербургская кухня",
        "body": "Петербург строился как европейский город, и его кухня с самого начала была синтетической: французские соусы, немецкий хлеб, финские рыбные традиции, русские заготовки. 300 лет этого синтеза создали особую кухню, которую сложно назвать «русской» в традиционном смысле. Петербургская кухня в 2026 году: нордические техники (копчение, ферментация, маринование) + балтийские продукты + авторский подход петербургских шефов.",
        "list": [
          "Уха и рыбная кухня — исторический центр",
          "Корюшка в апреле-мае — петербургский ритуал",
          "Нордические заготовки: маринованные и копчёные продукты",
          "Петербургские десерты: «Птичье молоко» — городская легенда"
        ]
      },
      {
        "heading": "Что обязательно попробовать",
        "body": "Для туриста и первого визита: корюшка (апрель-май — если в сезон), уха из местной рыбы, гребешки (доступный местный деликатес), десерт «Птичье молоко» в авторском исполнении. Всё это в полной мере есть в «Парусах на крыше» — авторская кухня с петербургским характером.",
        "highlight": "Весной (апрель-май) обязательно: корюшка в «Парусах». Запах свежей корюшки — петербургский признак весны. Местные знают и любят этот ритуал."
      },
      {
        "heading": "Петербургская кухня в «Парусах»",
        "body": "Шеф «Парусов» работает в петербургской гастрономической традиции: продукты Северо-Запада, нордические техники, европейская культура подачи. Это не «русская кухня для туристов», а настоящее место, где шеф понимает свою гастрономическую идентичность. Именно поэтому гости из других городов так часто говорят: «это лучшее, что я ел в Петербурге». Читайте также: <a href=\"/blog/lokalnyye-produkty-severo-zapad-kukhnya\" class=\"underline text-accent\">локальные продукты Северо-Запада в кухне</a>."
      }
    ],
    "cta": {
      "text": "Попробовать петербургскую кухню",
      "href": "/menu"
    }
  }
];
